// extracted by mini-css-extract-plugin
export default {"largeExclamationWrapper":"LargeExclamation-module--large-exclamation-wrapper--e8894"};